import { useReducer, useEffect, useCallback } from "react";
import { PreLoader } from "../../element";
import { createContext } from "react";
import { reducer } from "./reducer";
import { initialState } from "./initialsState";
import { useService } from "../../hooks";

export const AppContext = createContext(null);
export const AppData = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const { fetchByAttr } = useService("Data", "setting");

  const fetchSettings = useCallback(async () => {
    const logoResult = await fetchByAttr({ key: "logo" });
    if (logoResult.status && logoResult.data.length > 0) {
      dispatch({ type: "SET_LOGO", payload: logoResult.data[0].value });
    }
    const logoWhiteResult = await fetchByAttr({ key: "logoWhite" });
    if (logoWhiteResult.status && logoWhiteResult.data.length > 0) {
      dispatch({ type: "SET_LOGO_WHITE", payload: logoWhiteResult.data[0].value });
    }
  }, [fetchByAttr]);

  useEffect(() => {
    fetchSettings();
  }, [fetchSettings]);

  const appData = {
    dispatch,
    actions: {
      showPreloader: () => dispatch({ type: "SET_LOADING", payload: true }),
      hidePreloader: () => dispatch({ type: "SET_LOADING", payload: false }),
      setServices: (payload) => dispatch({ type: "SET_SERVICES", payload }),
      setProducts: (payload) => dispatch({ type: "SET_PRODUCTS", payload }),
      setMicroServices: (payload) =>
        dispatch({ type: "SET_MICRO_SERVICES", payload }),
      setLogo: (payload) => dispatch({ type: "SET_LOGO", payload }),
      setLogoWhite: (payload) => dispatch({ type: "SET_LOGO_WHITE", payload }),
    },
    selectors: {
      getLoading: () => state.loading,
      getServices: () => state.services,
      getProducts: () => state.products,
      getMicroServices: () => state.microServices,
      getLogo: () => state.logo,
      getLogoWhite: () => state.logoWhite,
    },
  };

  return (
    <AppContext.Provider value={appData}>
      {state.loading && <PreLoader />}
      {children}
    </AppContext.Provider>
  );
};
